<!-- =========================================================================================
File Name: RegisterJWT.vue
Description: Register Page for JWT
----------------------------------------------------------------------------------------
Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<!--<template>
<div class="clearfix">
  <vs-input
    v-validate="'required|alpha_dash|min:3'"
    data-vv-validate-on="blur"
    label-placeholder="Mobile No"
    name="mobileNo"
    placeholder="Mobile No"
    v-model="mobileNo"
    class="w-full" />
  <span class="text-danger text-sm">{{ errors.first('mobileNo') }}</span>

  <vs-input
    ref="password"
    type="password"
    data-vv-validate-on="blur"
    v-validate="'required|min:6|max:10'"
    name="password"
    label-placeholder="Password"
    placeholder="Password"
    v-model="password"
    class="w-full mt-6" />
  <span class="text-danger text-sm">{{ errors.first('password') }}</span>

  <vs-input
    type="password"
    v-validate="'min:6|max:10|confirmed:password'"
    data-vv-validate-on="blur"
    data-vv-as="password"
    name="confirm_password"
    label-placeholder="Confirm Password"
    placeholder="Confirm Password"
    v-model="confirm_password"
    class="w-full mt-6" />
  <span class="text-danger text-sm">{{ errors.first('confirm_password') }}</span>

  <vs-checkbox v-model="isTermsConditionAccepted" class="mt-6">I accept the terms & conditions.</vs-checkbox>
  <vs-button  type="border" to="/pages/login" class="mt-6">Login</vs-button>
  <vs-button class="float-right mt-6" @click="registerUserJWt" :disabled="!validateForm">Register</vs-button>
</div>
</template>-->
<template>
  <div class="clearfix">
    <vs-input
    type="tel"
    v-validate="'required|min:11|max:11'"
    data-vv-validate-on="blur"
    label-placeholder="Mobile No"
    name="mobileNo"
    placeholder="Mobile No"
    v-model="mobileNo"
    class="w-full" />
  <span class="text-danger text-sm">{{ errors.first('mobileNo') }}</span>


    <vs-input
    ref="password"
    type="password"
    data-vv-validate-on="blur"
    v-validate="'required|min:6|max:10'"
    name="password"
    label-placeholder="Password"
    placeholder="Password"
    v-model="password"
    class="w-full mt-6" />
  <span class="text-danger text-sm">{{ errors.first('password') }}</span>

    <vs-input
    type="password"
    v-validate="'min:6|max:10|confirmed:password'"
    data-vv-validate-on="blur"
    data-vv-as="password"
    name="confirm_password"
    label-placeholder="Confirm Password"
    placeholder="Confirm Password"
    v-model="confirm_password"
    @keydown.enter.prevent="createAccount"
    class="w-full mt-6" />
  <span class="text-danger text-sm">{{ errors.first('confirm_password') }}</span>


  <vs-checkbox v-model="isTermsConditionAccepted" class="mt-6">I accept the terms & conditions.</vs-checkbox>
  <vs-button  type="border" to="/pages/login" class="mt-6">Login</vs-button>
  <vs-button class="float-right mt-6" @click="createAccount" :disabled="!validateForm">Register</vs-button>

<!--    <vs-checkbox v-model="isTermsConditionAccepted" class="mt-6">I accept the terms & conditions.</vs-checkbox>-->
<!--    <vs-button type="border" to="/pages/login" class="mt-6">Login</vs-button>-->
<!--    <vs-button :disabled="regBtnDisable == false" class="float-right mt-6" @click="createAccount">Register</vs-button>-->
  </div>
</template>
<!--<script>
  export default {
    data () {
      return {
        mobileNo: '',
        email: '',
        password: '',
        confirm_password: '',
        isTermsConditionAccepted: true
      }
    },
    computed: {
      validateForm () {
        return !this.errors.any() && this.mobileNo !== '' && this.password !== '' && this.confirm_password !== '' && this.isTermsConditionAccepted === true
      }
    },
    methods: {
      checkLogin () {
        // If user is already logged in notify
        if (this.$store.state.auth.isUserLoggedIn()) {

          // Close animation if passed as payload
          // this.$vs.loading.close()

          this.$vs.notify({
            title: 'Login Attempt',
            text: 'You are already logged in!',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          })

          return false
        }
        return true
      },
      registerUserJWt () {
        // If form is not validated or user is already login return
        if (!this.validateForm || !this.checkLogin()) return

        const payload = {
          userDetails: {
            displayName: this.displayName,
            email: this.email,
            password: this.password,
            confirmPassword: this.confirm_password
          },
          notify: this.$vs.notify
        }
        this.$store.dispatch('auth/registerUserJWT', payload)
      }
    }
  }
</script>-->

<script>
  import RegisterJwt from './RegisterJWT.vue'
  import CreateAccount from '../../../graphql/CreateAccount.gql'
  import { onLogin } from '../../../vue-apollo'
  import gql from 'graphql-tag'
  const meQuery = gql`
  query me {
    me{
      id
      phone
      name
      ekyc{
      status
        parsonal{
          id
          name
          father_name
          mother_name
          spouse_name
          age
          marital_status
          gender
          head_of_household
          education_level
          nid
          nid_front
          nid_back
          photo
        }
      }
   }
}`
  export default {
    data () {
      return {
        mobileNo: '',
        password: '',
        confirm_password: '',
        isTermsConditionAccepted: false,
        msg: '',
        regBtnDisable: false
      }
    },
    computed: {
      validateForm () {
        return !this.errors.any() && this.mobileNo !== '' && this.password !== '' && this.confirm_password !== '' && this.isTermsConditionAccepted === true
      }
    },
    watch: {
      me(value){
        console.log("Me computed value: ", value);
        console.log("Me computed: ", this.me);
        if(this.me !== null && this.me !== undefined){
          if(this.me.ekyc.status == 1 || this.me.ekyc.status == 2){
            this.$router.push('/applicantInfo').catch(() => {});
          }else {
            this.$router.push('/applicantDashboard').catch(() => {});
          }
        }
      }
    },
    methods: {
    checkLogin () {
        // If user is already logged in notify
        if (this.$store.state.auth.isUserLoggedIn()) {

          // Close animation if passed as payload
          // this.$vs.loading.close()

          this.$vs.notify({
            title: 'Login Attempt',
            text: 'You are already logged in!',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          })

          return false
        }
        return true
      },
      async createAccount () {
        await this.$apollo.mutate({
          mutation: CreateAccount,
          variables: {
            phone: this.mobileNo,
            password: this.password
          }
        }).then((data) => {
          console.log('Data = ', data)
          if (data.data.signup == null) {
            this.msg = 'Invalid User'
            function getRandomInt(min, max) {
              return Math.floor(Math.random() * (max - min)) + min;
            }
            let color = `rgb(${getRandomInt(0,255)},${getRandomInt(0,255)},${getRandomInt(0,255)})`
            this.$vs.notify({
              title: 'Registration',
              text: 'Something went wrong !',
              color: "danger"
            })
          } else {
            this.$store.dispatch('userToken', data.data.login)
            onLogin(this.$apollo.provider.defaultClient, data.data.login)
            function getRandomInt(min, max) {
              return Math.floor(Math.random() * (max - min)) + min;
            }
            let color = `rgb(${getRandomInt(0,255)},${getRandomInt(0,255)},${getRandomInt(0,255)})`
            this.$vs.notify({
              title: 'Registration',
              text: 'Registration Done and you are Successfully logged in.',
              color: "success"
            })
            console.log("Meeeee", this.me);
            this.$router.push('/').catch(() => {
            })
          }
          //this.$store.dispatch('userToken', data.data.signup)
          onLogin(this.$apollo.provider.defaultClient, data.data.signup)


          // this.$store.dispatch('loadUserInfo',data.data.signup)
        }).catch((error) => {
          // let { graphQLErrors } = error;
          // if (graphQLErrors[0].extensions.category === "validation") {
          //   this.validationErrors = graphQLErrors[0].extensions.validation;
          // }
        })
      },
      checkConfirmPass(confirmPass){
        console.log("pass", this.password);
        console.log("con pass", confirmPass);
        if(this.password != null && confirmPass != null){
          if(this.password == confirmPass){
            console.log("machggg");
            this.regBtnDisable = false;
          }
        }

      },
      // checkLogin () {
      //   // If user is already logged in notify
      //   if (this.$store.state.auth.isUserLoggedIn()) {
      //
      //     // Close animation if passed as payload
      //     // this.$vs.loading.close()
      //
      //     this.$vs.notify({
      //       title: 'Login Attempt',
      //       text: 'You are already logged in!',
      //       iconPack: 'feather',
      //       icon: 'icon-alert-circle',
      //       color: 'warning'
      //     })
      //
      //     return false
      //   }
      //   return true
      // },

      registerUserJWt () {
        console.log('Clicked')
      }

      //If form is not validated or user is already login return
      //   if (!this.validateForm ) return
      //   const payload = {
      //     userDetails: {
      //       displayName: this.mobileNo,
      //       password: this.password,
      //       confirmPassword: this.confirm_password
      //     },
      //     notify: this.$vs.notify
      //   }
      //   console.log("Clicked", payload);
      //   this.$store.dispatch('auth/registerUserJWT', payload)
      // }
    }
  }
</script>
